import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { CollectApp } from './CollectApp';

const container = document.getElementById('root');

if (container === null) {
  throw new Error('마운트 지점 #root를 찾을 수 없습니다.');
}

/*
 * 질의 문자열을 여기서 한 번 읽어 넘긴다. 컴포넌트가 `window.location`을 직접 읽으면
 * 모드 판정을 검사할 수 없다.
 */
createRoot(container).render(
  <StrictMode>
    <CollectApp search={window.location.search} />
  </StrictMode>,
);
